import { Helmet } from "react-helmet-async";
import { Container } from "@mui/material";
import ClubForm from "src/components/ClubForm";

export default function CreateClubPage() {
  return (
    <>
      <Helmet>
        <title>Create Club</title>
      </Helmet>

      <Container maxWidth="lg">
        <ClubForm mode="create" />
      </Container>
    </>
  );
}
